import React from 'react'
function QRCodes() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_changelog">
               <h1>QR Codes</h1>
               <hr/>
               <p className='mt-30'>
                  Safexpay offers smart, robust, secure and convenient solution to your payment worries with our simple QR code modes of payments:
               </p>
               <p>
                  <b>1. UPI QR Code</b> <br/>
                  Low-cost merchant acquisition becomes easier. Moreover, younger customers are becoming more and more time oriented. They want a solution that is readily available in their hand. 
               </p>
               <p>
                  <b>2. Flexi QR Code </b><br/>
                  Both online and offline merchants can accept money from their end customers by using this payment feature that enables them to scan directly through their phone’s camera without having to install any other apps. 
               </p>
               <h5>
                  QR Code - Use Cases 
               </h5>
               <ul>
                  <li>Information Technology</li>
                  <li>Education</li>
                  <li>Government</li>
                  <li>Banking</li>
                  <li>NBFC</li>
                  <li>Tech</li>
                  <li>Corporate</li>
                  <li>Insurance</li>
               </ul>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default QRCodes